import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core';
import DataGrid from '@dataGrid';
import GridConfig from './RoutesSummaryGridConfig';
import { getRoutesCount, processRoutesData } from './utils';

const styles = (theme) => ({
  container: {
    flex: 2,
    marginBottom: 12,
    minHeight: 150
  },
  otherRoutesContainer: {
    flex: 1
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    textTransform: 'uppercase',
    marginBottom: 8,
    letterSpacing: 0.8,
    height: 20
  },
  dataGrid: {
    height: 'calc(100% - 28px)', //total height - height of label - margin between
    marginBottom: 24,
    width: '100%',
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    }
  },
  primaryIcon: {
    color: theme.palette.primary.main
  }
});

const FeedbackRoutesSummary = ({ icon, label, data, classes, isExtraRoute }) => {
  const gridConfig = useRef(new GridConfig({ isExtraRoute }));
  const processedData = processRoutesData(data, isExtraRoute);
  const routesCount = getRoutesCount(processedData);
  return (
    <div className={`${classes.container} ${isExtraRoute ? classes.otherRoutesContainer : ''}`}>
      <div className={classes.label}>
        <div className={isExtraRoute ? classes.primaryIcon : ''}>
          <i className={icon} />
        </div>
        <div>
          {label} ({routesCount})
        </div>
      </div>
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={gridConfig.current.config.defaultColDef}
          columnDefs={gridConfig.current.config.columns}
          config={gridConfig.current.config}
          rowData={processedData}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(FeedbackRoutesSummary);
